<template>
  <base-dialog
    :title="'house.param.doors.title' | i18n"
    :subtitle="'house.param.doors.subtitle' | i18n"
    :description="'house.param.doors.description' | i18n">


    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/house_doors.jpg" />
        </div>

        <div class="col-8">
          <label>Ulko-ovien määrä kpl</label>
          <select v-model="numOfDoors" class="form-control">
            <option v-for="n in 10" :value="n-1">{{ n-1 }}</option>
          </select>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import Vue from 'vue'
  import BaseDialog from "./BaseDialog"
  import townService from "../../api/townService";
  import { mapState } from 'vuex'

  export default {
    computed: {
      numOfDoors: {
        get() {
          return this.$store.state.houseParams.numOfDoors
        },
        set(numOfDoors) {
          this.$store.commit('houseParams/SET_NUM_OF_DOORS', numOfDoors)
        }
      }
    },

    data() {
      return {

      }
    },

    created() {
      if(this.numOfDoors == null) {
        this.$store.commit('houseParams/SET_NUM_OF_DOORS', 0)
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    max-width: 100%;
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseDoorsDialog.vue